import i18n from '@/i18n'
import store from '@/store'
import FormValidationRules from '@/components/shared/forms/FormValidationRules'
import { GET_BLACKLISTED_EMAIL_DOMAINS } from '@/store/get-types'

const emailDomainIsNotBlacklisted = email => {
  const emailAddress = email || ''
  const [emailDomain] = emailAddress.split('.').slice(-1)
  const blacklistedDomains = store.getters[GET_BLACKLISTED_EMAIL_DOMAINS]

  return (
    !blacklistedDomains.includes(emailDomain.toLowerCase()) ||
    i18n.t('checkout-blacklisted-email-domain', { domain: emailDomain })
  )
}

const DigitalDeliveryFormSchema = {
  fluid: true,
  fields: [
    {
      type: 'v-text-field',
      model: 'firstName',
      props: {
        id: 'checkout-digital-first-name',
        name: 'checkout-digital-first-name',
        label: i18n.t('checkout-recipient-first-name'),
        outlined: true,
        'aria-label': i18n.t('checkout-recipient-first-name'),
        maxlength: '100',
        autocomplete: 'off',
        autocorrect: 'off',
        autocapitalize: 'off',
        spellcheck: 'false',
        'aria-invalid': 'false',
        rules: [
          FormValidationRules.required(
            i18n.t('checkout-recipient-first-name-valid')
          )
        ]
      }
    },
    {
      type: 'v-text-field',
      model: 'lastName',
      props: {
        id: 'checkout-digital-last-name',
        name: 'checkout-digital-last-name',
        label: i18n.t('checkout-recipient-last-name'),
        outlined: true,
        'aria-label': i18n.t('checkout-recipient-last-name'),
        maxlength: '100',
        autocomplete: 'off',
        autocorrect: 'off',
        autocapitalize: 'off',
        spellcheck: 'false'
      }
    },
    {
      type: 'v-text-field',
      model: 'email',
      label: i18n.t('checkout-recipient-email'),
      rules: [
        FormValidationRules.required(i18n.t('checkout-recipient-email-valid')),
        FormValidationRules.email(i18n.t('checkout-recipient-email-valid')),
        emailDomainIsNotBlacklisted
      ]
    }
  ]
}

export default DigitalDeliveryFormSchema
